'use client';

import { makeStyles, tokens } from '@fluentui/react-components';

export const useAttachmentDescriptionStyles = makeStyles({
  root: {
    display: 'block',
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
    lineHeight: 1,
  },
});
